import axios from 'axios'
// import { getToken } from '@/utils/tokenUtil'
// import { Message } from 'element-plus'//此处是element-ui如果是plus则是'element-plus'
// import router from '@/'
// 创建axios实例
const request = axios.create({
    // 这里可以放一下公用属性等。
    baseURL: 'https://snkapi.sd-reading.com', // 用于配置请求接口公用部分，请求时会自动拼接在你定义的url前面。
    // baseURL: 'http://192.168.0.10:8084',
    withCredentials: false, // 跨域请求时是否需要访问凭证
    timeout: 3 * 1000, // 请求超时时间

})

// 请求拦截器
request.interceptors.request.use((config) => {
    config.headers["Content-Type"] = "application/json";
    config.headers["current_client_type"] = "browserClient";
    config.headers["deviceType"] = "3";
    const token = localStorage.getItem("token");
    const clientId = localStorage.getItem("clientId");
    config.headers["clientId"] = clientId;
    if (token)
        config.headers["Authorization"] = 'Bearer ' + token;
    return config;
}, (error) => {
    return Promise.reject(error)
})

request.interceptors.response.use((response) => {
    let { code, msg } = response.data

    if (code != 200) {
        return Promise.reject(response.data)
    }
    return response.data;
}, (error) => {
    console.log(error);

    return Promise.reject(error)
})

export default request;